export const BLOCKED_ENROLLMENT_PERIOD_MESSAGE =
  'Alunos do seu período de ingresso não estão autorizados a solicitar análises no momento.'

const BLOCKED_ENROLLMENT_PERIOD_MATCH = 'período de ingresso'

export function isBlockedEnrollmentPeriodError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')

  return message.includes(BLOCKED_ENROLLMENT_PERIOD_MATCH)
}
